import { splitProps } from 'solid-js';
import { Dynamic } from 'solid-js/web';
import { cn, tv } from 'tailwind-variants';
import type { JSX } from 'solid-js';
import type { VariantProps } from 'tailwind-variants';

type HTag = VariantProps<typeof classes>['level'];
type Props<E extends HTag = HTag> = JSX.HTMLAttributes<HTMLHeadingElement> & {
	level: E;
	size?: HTag;
};
export function Heading(props: Props) {
	const [, rest] = splitProps(props, ['level', 'size']);
	return (
		<Dynamic component={props.level} {...rest} class={cn(classes({ level: props.size ?? props.level }), props.class)}>
			{props.children}
		</Dynamic>
	);
}

const classes = tv({
	base: '',
	variants: {
		level: {
			h1: 'text-4xl font-bold tracking-tight sm:text-5xl',
			h2: 'text-3xl font-bold tracking-tight sm:text-4xl',
			h3: 'text-2xl font-bold tracking-tight sm:text-3xl',
			h4: 'text-xl font-semibold tracking-tight sm:text-2xl',
			h5: 'text-xl font-semibold sm:text-xl',
			h6: 'text-lg font-semibold',
			p: 'text-base font-semibold',
		},
	},
});
